import Iodine from '@caneara/iodine'
const IodineInstance = new Iodine()

export default () => ({
    isValid: false,
    success: false,
    errors: {},

    submitForm(event) {
        this.errors = {}

        event.preventDefault()
        event.stopImmediatePropagation()

        const form = this.$el

        let inputs = [...form.querySelectorAll('[data-rules]')]

        this.isValid = true

        IodineInstance.setErrorMessages({
            required: 'This field is required',
        })

        inputs.map((input) => {
            let assertion = IodineInstance.assert(
                input.value,
                JSON.parse(input.dataset.rules)
            )

            if (assertion !== true) {
                console.log('INPUT', input)
                console.log('ASSERTION', assertion)
                console.log('------')
                if (assertion.valid === false) {
                    this.errors[input.name] = assertion.error
                }
            }
        })

        if (this.hasErrors()) {
            return
        }

        // formdata
        const formData = new FormData(form)
        const data = Object.fromEntries(formData.entries())

        // serialize data to urlencoded
        const urlEncoded = new URLSearchParams(data).toString()

        console.log('URL ENCODED', urlEncoded)

        // make fetch request
        fetch('/', {
            method: form.method,
            body: urlEncoded,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        })
            .then((response) => response.json())
            .then((data) => {
                console.log('ResponseData', data)

                if (data.success) {
                    this.success = true
                }
            })
    },
    hasErrors() {
        return Object.keys(this.errors).length > 0
    },
    hasError(field) {
        console.log('HAS ERROR', field)
        return this.errors.hasOwnProperty(field)
    },
    getError(field) {
        return this.errors[field]
    },
})
